import { render, staticRenderFns } from "./capital-market-publications-technical-error.vue?vue&type=template&id=97bd8688&lang=pug&"
import script from "./capital-market-publications-technical-error.vue?vue&type=script&lang=js&"
export * from "./capital-market-publications-technical-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports